import { z } from 'zod';

import { fieldNames } from './SaveAndApprovePopupContent.constants';

export const schema = z.object({
    [fieldNames.comment]: z.string().optional(),
});
